import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import test from '../views/test.vue'
import notfount from '../views/notFount.vue'
import pay from '../views/pay.vue'
import loadpay from '../views/loadpay.vue'
import otherPay from '../views/otherPay.vue'
import bankPay from '../views/bankPay'
import otherDjPay from '../views/otherDjPay.vue'
import otherDjInfo from '../views/otherDjInfo.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },{
    path: '/bankPay',
    name: 'bankPay',
    component: bankPay
  },
  {
    path: '/x/:name([a-z0-9]{3,6})/:user([a-z0-9]{2,8})/:word([a-z0-9]{8,10})',
    name: 'otherPay',
    component: otherPay
  },
  {
    path: '/:name([a-z0-9]{5,8})/:user([a-z0-9]{8,12})/:word([a-z0-9]{12,18})',
    name: 'pay',
    component: pay
  },
  {
    path: '/:name([a-z0-9]{1,1})/:name([a-z0-9]{5,8})/:user([a-z0-9]{8,12})/:word([a-z0-9]{12,18})',
    name: 'loadpay',
    component: loadpay
  },
  {
    path: '/x/otherDjPay',
    name: 'otherDjPay',
    component: otherDjPay
  },
  {
    path: '/v/otherDjInfo',
    name: 'otherDjInfo',
    component: otherDjInfo
  },
  // {
  //   path: '/:name([a-z0-9]{5,8})/:user([a-z0-9]{8,12})/:word([a-z0-9]{12,18})',
  //   name: 'test',
  //   component: test
  // },
  {
    path: '*',
    name: 'notfount',
    component: notfount
  }

]

const router = new VueRouter({
  routes
})

export default router